module.exports = function(posts) {
	"use strict";
  posts
  .controller('usElectionController', usElectionController)
	usElectionController.$inject = ["keyPressOnlyNumber","API_URL","$http","$scope","$state","getDataService","refreshtokenService","$attrs","putDataService","alertService","$rootScope","serverError","checkArray","postDataService","offlineError"]
	
  function usElectionController(keyPressOnlyNumber,API_URL,$http,$scope,$state,getDataService,refreshtokenService,$attrs, putDataService, alertService,$rootScope,serverError, checkArray, postDataService,offlineError) {
    var vmue = this;
    vmue.checkboxes = {}
    vmue.keyPressOnlyNumber = keyPressOnlyNumber;
    vmue.saveChanges = function() {
      if(!vmue.dt_total && vmue.dt_total !== 0) {
        alertService('danger','Opps! ', 'Total electoral votes is required.');
        vmue.dtTotalRequied = true
        return
      }
      if(!vmue.kh_total && vmue.kh_total !== 0) {
        alertService('danger','Opps! ', 'Total electoral votes is required.');
        vmue.khTotalRequied = true
        return
      }
      for (var i = 0; i< vmue.usElectionArray.length;i++) {
        vmue.usElectionArray[i].winner = vmue.checkboxes[vmue.usElectionArray[i].id] 
      }
      var putData = {
        'dt_total':parseInt(vmue.dt_total),
        'kh_total':parseInt(vmue.kh_total),
        'widget_url':vmue.widgetUrl,
        'states': vmue.usElectionArray
      };
      var putFunction = function() {
        $http.put(API_URL + 'us_election' , putData)
        .success(function (data, status, headers) {
            alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError();
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
        });
      }
      putFunction();
    }
    var getElectionsFunction = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:'us_election'}).$promise.then(function(data){
        $rootScope.hasLoaded = true;
        if(!data.result) return;
        if(data.result.states && data.result.states.length>0) {
          vmue.usElectionArray = data.result.states
          for (var i = 0; i< vmue.usElectionArray.length;i++) {
            vmue.checkboxes[vmue.usElectionArray[i].id] = vmue.usElectionArray[i].winner
          }
        }
        if('dt_total' in data.result) {
          vmue.dt_total = data.result.dt_total
        }
        if('kh_total' in data.result) {
          vmue.kh_total = data.result.kh_total
        }
        if('widget_url' in data.result) {
          vmue.widgetUrl = data.result.widget_url
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getElectionsFunction();
              }
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }  
        $rootScope.hasLoaded = true;
      }); 
    }
    getElectionsFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/usElection/js/usElectionController.js
// module id = 573
// module chunks = 0